__turbopack_context__.v({
  "dropdown_btn": "bl0M2W_dropdown_btn",
  "dropdown_placeholder": "bl0M2W_dropdown_placeholder",
  "listOverlay": "bl0M2W_listOverlay",
  "listStyle": "bl0M2W_listStyle",
});
